export default __webpack_public_path__ + "static/media/image_2.77fa2328.jpg";